/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ach/view.blocks to change it.
import HolderFirstName from './HolderFirstName/index'
import HolderLastName from './HolderLastName/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Ach({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields/Bluefin/Ach"
  
}) {
  return (<React.Fragment
>
<HolderFirstName
  viewPath={`${viewPath}/HolderFirstName`}
/>
<HolderLastName
  viewPath={`${viewPath}/HolderLastName`}
/>
{children}
</React.Fragment>)
}